export default "__VITE_ASSET__C84NEHgn__"